// Turns an axios error into something a form can render.
//
// FastAPI 422s carry detail as an ARRAY of {loc, msg, type}; every other error
// carries a string. Passing the array to toast.error() renders nothing useful,
// so forms go through here: `fieldErrors` is keyed by the offending field
// (the last string segment of `loc`), `message` is always a plain string.

const cleanMsg = (msg) => String(msg || 'Invalid value').replace(/^Value error,\s*/i, '');

export function parseApiError(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;

  if (err?.response?.status === 422 && Array.isArray(detail)) {
    const fieldErrors = {};
    detail.forEach((e) => {
      const field = [...(e.loc || [])].reverse().find((seg) => typeof seg === 'string' && seg !== 'body');
      const msg = cleanMsg(e.msg);
      if (field && !fieldErrors[field]) fieldErrors[field] = msg;
    });
    const first = detail[0] ? cleanMsg(detail[0].msg) : fallback;
    return { fieldErrors, message: first };
  }

  return { fieldErrors: {}, message: typeof detail === 'string' ? detail : fallback };
}
